<script setup lang="ts">
const NuxtLink = resolveComponent('NuxtLink')

defineProps<{
  to: string
  size?: 'small' | 'large'
}>()
</script>

<template>
  <Button
    :as="NuxtLink"
    :to="to"
    :size="size"
  >
    <slot />
  </Button>
</template>
